import { USER_LOAD_STATUSES } from '@/constants/users.js';

// The 4xx codes that are a retryable condition rather than a verdict on the author: a server-side
// request timeout and a rate limit both mean "ask again", exactly like a 5xx.
const TRANSIENT_CLIENT_ERRORS = [ 408, 429 ];

// A rejected author read used to be indistinguishable from a real user: the queue silently substituted
// the default user, so the row rendered a person called "Unassigned" who joined seconds ago with no
// bans. The two failure shapes need different treatment, so classify before deciding what to render.
//
// MISSING — the section does not hold this author, and asking again will not change that: a 404, or a
// 4xx that is a settled answer (401/403 on scope, 400 on a malformed uuid). Platform-wide these run in
// the hundreds of thousands per day while CM-1741 is open, so a scary error state here would make every
// sectioned site's queue look broken. Keep the neutral placeholder.
//
// UNAVAILABLE — a 5xx, a transient 4xx above, a network error or a timeout. The author exists as far as
// we know and a retry may well succeed, so the row must say so rather than inventing a user. An error
// with no response (network failure, client-side timeout, or a thrown non-HTTP error) falls here too:
// it is a failure to read, never evidence that the author is absent.
export const classifyUserLoadFailure = (error) => {
    const status = error && error.response && error.response.status;

    if (!status || status >= 500 || TRANSIENT_CLIENT_ERRORS.includes(status)) {
        return USER_LOAD_STATUSES.UNAVAILABLE;
    }

    return USER_LOAD_STATUSES.MISSING;
};

export const isTransientUserLoadFailure = (error) =>
    classifyUserLoadFailure(error) === USER_LOAD_STATUSES.UNAVAILABLE;
